/**
* =========================================================================================
* Component - Icon
* ========================================================================================= 
**/

import React from 'react';

import { hexToRgba } from "../common/function";

const UIcon = (props) => {

    const handle = {
        styles: () => {
            return {
                width: props?.thumb, 
                height: props?.thumb
            }
        }, 
        bgColor: () => {
            return {
                backgroundColor: props?.color ? hexToRgba(props?.color, 0.1) : '',
                color: props?.color
            }
        }
    }

    return ( 
        <React.Fragment>
            
            <div className={`u_round-icon ${props?.type === 'square' ? 'square' : ''}`} style={handle.styles()}>
                <div className="u_round-icon-inner u_icon-color" style={handle.bgColor()}>
                    { props?.icon }
                </div>
            </div>
                    
        </React.Fragment>
    );
}
 
export default UIcon;